import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`

    .t-header-root {
        width: 100%;
    }

    .t-layout-content {
        align-items: center;
    }

    .t-layout-body  {
        max-width: min(100%, 1272px);
       
    }

    .t-select-listbox::-webkit-scrollbar-track {
      background: transparent;
      margin: 10px 0; 
    }
    
    .t-select-listbox::-webkit-scrollbar-thumb {
      border-radius: 4px;
    }
    
    .t-select-listbox::-webkit-scrollbar-thumb:hover {
    }

    .t-input-field:disabled,
    .t-textarea-field:disabled,
    .t-input-wrapper input:disabled,
    .t-inputdate-wrapper input:disabled {
        color: #666666 !important;
        background-color: #ebebeb !important;
    }

    .t-input-wrapper:has(input:disabled),
    .t-inputdate-wrapper:has(input:disabled) {
        background-color: #ebebeb !important;
        line-height: unset !important;

        ::placeholder {
            color: #666666 !important;
        }
    }

    .t-select-trigger:disabled {
        background-color: #ebebeb !important;

        ::placeholder {
            color: #666666 !important;
        }
    }

    .t-select-trigger:disabled div {
        color: #666666 !important;
    }
    
    .t-select-trigger[aria-disabled='true'],
    .t-input-wrapper[aria-disabled='true'],
    .t-inputdate-wrapper[aria-disabled='true'] {
        background-color: #ebebeb !important;
        color: #666666 !important;
    }

    input:disabled,
    textarea:disabled,
    select:disabled {
        color: #666666 !important;
        background-color: #ebebeb !important;
    }
    .select-container:has(textarea:disabled) {
        background-color: #ebebeb !important;

        ::placeholder {
            color: #666666 !important;
        }
    }
        
    div.t-text.text-gray-900.text-base {
        white-space: normal !important;
        text-overflow: unset !important;
  }
`;

export default GlobalStyles;

export const SelectStyles = createGlobalStyle`
    .t-select-listbox > li[role="option"]{
        width: 390px;
    }

    .t-select-listbox > li[role="option"] > div {
        white-space: initial !important;
    }    
    `;

export const ChatStyles = createGlobalStyle`
    .t-layout-root {
        box-sizing: border-box !important;
        height: 100vh !important;
        max-height: 100vh !important;
        overflow: hidden !important;
    }

    .t-layout-content {
        padding-bottom: 0 !important;
        gap: 0 !important;
        padding-right: 0 !important;
        min-height: 0 !important;
        overflow: hidden !important;
    }

    .t-header-root {
        flex-shrink: 0 !important;
        padding-right: 38px;
    }

    .t-layout-body {
        margin-left: -38px !important;
        overflow: hidden !important;
        max-width: 100vw !important;
        width: calc(100cqi - 296px) !important;
        flex: 1 !important;
        min-height: 0 !important;
        height: auto !important;
    }

    @media (min-width: 768px) {
        div[data-extend-navbar='false'] .t-layout-content .t-layout-body {
            width: calc(100cqi - 84px - 1px) !important;
        }
    }

    @media (max-width: 767px) {
        .t-layout-content .t-layout-body {
            width: calc(100vw - 40px);
            width: calc(100cqi - 40px) !important;
        }
    }
`;

export const SelectOverlabelCDIA = createGlobalStyle`
      .t-select-overLabel{
       display: flex;
       flex-direction: column-reverse;

    }
      .t-select-overLabel > div:first-child{
       letter-spacing: 0.15px;
    }
`;

export const PeiPageStyle = createGlobalStyle`
  .t-layout-body {
    overflow-y: hidden;
  }
`;

export const CSATStyles = createGlobalStyle`
  .t-dialog-rating {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 8px;
    border: none !important;
    opacity: 0;
  }

  .t-dialog-rating.stars-ready {
    opacity: 1;
  }

  .csat-stars-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  form[name="csat"].t-dialog-root {
    width: clamp(360px, 42vw, 760px) !important;
  }

  .t-dialog-rating div {
    border: none !important;
    background: transparent !important;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 !important;
    flex: none !important;
    color: transparent !important;
    font-size: 0 !important;
    text-indent: -9999px !important;
    overflow: hidden;
    margin: 24px 0 !important;
  }

  .t-dialog-rating div .hidden-number {
    display: none;
    color: transparent !important;
  }

  .t-dialog-rating div .svg-vazio {
    display: flex;
  }
  .t-dialog-rating div .svg-cheio {
    display: none;
  }

  .t-dialog-rating div .svg-vazio,
  .t-dialog-rating div .svg-cheio,
  .t-dialog-rating div .svg-vazio *,
  .t-dialog-rating div .svg-cheio * {
    pointer-events: none;
  }

  .t-dialog-rating div.active .svg-vazio,
  .t-dialog-rating div.active-hover .svg-vazio {
    display: none !important;
  }

  .t-dialog-rating div.active .svg-cheio,
  .t-dialog-rating div.active-hover .svg-cheio {
    display: flex !important;
    color: #0d6efd;
  }
`;

export const MultiSelectChapters = createGlobalStyle`
    .chapters-select .t-select-listbox > li > fieldset {
    width: auto;
    display: contents;
    }

    .chapters-full .t-select-listbox > li[data-selected="false"] {
    pointer-events: none;
    opacity: 0.5;
    }
`;
